<template>
    <section class="experience-section nunito">
        <div class="content">
            <div class="between">
                <h2 class="title">Experiencia laboral</h2>
                <div class="stats">
                    <div class="stat-item">
                        <span class="stat-value montserrat">+12</span>
                        <span class="stat-label">Marcas / Empresas</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-value montserrat">+10</span>
                        <span class="stat-label">Paginas web</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-value montserrat">+10 </span>
                        <span class="stat-label">Años de Exp.</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ExperienceComponent',
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
body.dark-theme .experience-section {
    .content {
        .between {
            .title {
                color: white;
            }

            .stats {
                // background: #18afeb;

                .stat-item {

                    .stat-value {
                        color: white;
                    }

                    .stat-label {
                        color: #ebeaea;
                    }
                }
            }
        }
    }
}

.experience-section {
    width: 100%;
    padding: 20px;

    @media (max-width:$breakpoint-md) {
        margin-top:50px;
    }

    .content {
        margin: 0 auto;
        max-width: 1480px;
        width: 100%;

        .between {
            width: 80%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            @media (max-width:1153px) {
                justify-content: center;
                text-align: center;
            }
            

            .title {
                color:#0D0D0D;
                width: 300px;
                font-size: 1.8em;
                
                @media (max-width:1153px) {
                    width: 100%;
                    font-size: 1.5em;
                    text-align: center;
                }
                @media (max-width:$breakpoint-md) {
                    font-size:1.2rem;
                }
            }

            .stats {
                padding: 30px 10px 30px 30px;
                border-radius: 15px;
                // background:rgb(5, 47, 174);
                display: flex;
                flex-wrap: wrap;
                gap: 50px;
                justify-content: space-between;
                @media (max-width:$breakpoint-md) {
                    gap: 20px;
                    justify-content: center;
                }
                @media (max-width:1153px) {
                    padding: 15px 10px;
                }

                .stat-item {
                    min-width: 120px;
                    max-width: 150px;
                    @media (max-width: $breakpoint-md) {
                        min-width: 100px;
                        max-width: 130px;
                        text-align: center;
                    }
                    .stat-value {
                        display: block;
                        font-weight: bold;
                        font-size: 3.2em;
                        @media (max-width: $breakpoint-md) {
                            font-size: 1.8em;
                        }
                    }

                    .stat-label {
                        display: block;
                        font-weight: 700;
                        font-size: 1em;
                        @media (max-width: $breakpoint-md) {
                            font-size: 0.8em;
                        }
                    }
                }
            }
        }
    }
}
</style>